import React from "react";
const IconCountry = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M18 10H2m16 0a7.98 7.98 0 0 0-2.401-5.714A8 8 0 0 0 2 10m16 0a7.98 7.98 0 0 1-2.401 5.714A8 8 0 0 1 2 10"
    />
    <path stroke="currentColor" strokeWidth="2" d="M10 18s-3-2.857-3-8 3-8 3-8M10 18s3-2.857 3-8-3-8-3-8" />
  </svg>
);
export default IconCountry;
